import { createSlice } from '@reduxjs/toolkit';
import { AIAssistModel } from '../../models/ai.assist.model';

type initialStateType = {
  summary: AIAssistModel;
};

const initialState: initialStateType = {
  summary: null,
};

const currentDocumentAISummarySlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setCurrentDocumentAISummary(state, payload) {
      state.summary = payload.payload as AIAssistModel;
    },
    resetCurrentDocumentAISummary(state) {
      state.summary = null;
    },
  },
});

export const { setCurrentDocumentAISummary, resetCurrentDocumentAISummary } =
  currentDocumentAISummarySlice.actions;
export default currentDocumentAISummarySlice.reducer;
